import { apiFetch } from "./client";

export type SettlementStatus = "draft" | "final" | "paid";

export interface SettlementTotals {
  loadCount: number;
  linehaulCents: number;
  keepCents: number;
  detentionCents: number;
  totalCents: number;
}

export interface SettlementSummary {
  id: string;
  driverId: string;
  periodStart: string;
  periodEnd: string;
  status: SettlementStatus;
  finalizedAt: string | null;
  paidAt: string | null;
  totals: SettlementTotals;
}

export interface SettlementLoad {
  id: string;
  status: string;
  origin: string;
  destination: string;
  deliveredAt: string | null;
  paidAt: string | null;
  linehaulCents: number;
  keepCents: number;
  detentionCents: number;
}

export interface SettlementDetail {
  settlement: SettlementSummary;
  loads: SettlementLoad[];
}

export const SETTLEMENT_STATUS_LABEL: Record<SettlementStatus, string> = {
  draft: "Open",
  final: "Finalized",
  paid: "Paid",
};

export function listSettlements(): Promise<{ items: SettlementSummary[] }> {
  return apiFetch("/api/v1/settlements", {}, { retries: 0 });
}

export function getSettlement(id: string): Promise<SettlementDetail> {
  return apiFetch(`/api/v1/settlements/${id}`, {}, { retries: 0 });
}

export function settlementAction(id: string, action: "finalize" | "paid"): Promise<SettlementDetail & { ok: true }> {
  return apiFetch(`/api/v1/settlements/${id}/${action}`, { method: "POST", body: "{}" });
}

/** 'YYYY-MM-DD' pair → "Oct 5 – Oct 11". */
export function formatPeriod(start: string, end: string): string {
  const f = (d: string) =>
    new Date(`${d}T00:00:00Z`).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
  return `${f(start)} – ${f(end)}`;
}
